/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

type Dropdown1Props = {
  onBlacklist?: () => void
  onUnblacklist?: () => void
  blacklistLoading?: boolean
  unblacklistLoading?: boolean
  isAdmin?: boolean
}

export function Dropdown1({
  onBlacklist,
  onUnblacklist,
  blacklistLoading = false,
  unblacklistLoading = false,
  isAdmin = false,
}: Dropdown1Props) {
  // Only show dropdown if user is admin
  // console.log('isAdmin in Dropdown1:', isAdmin)
  // if (!isAdmin) {
  //   console.log('Dropdown1 not rendered because user is not admin')
  //   return null
  // }

  return (
    <div className='menu menu-sub menu-sub-dropdown w-200px' data-kt-menu='true'>
      <div className='px-5 py-4'>
        <div className='d-grid gap-2'>
          <button
            type='button'
            className='btn btn-sm btn-danger'
            onClick={onBlacklist}
            disabled={blacklistLoading || unblacklistLoading}
            data-kt-menu-dismiss='true'
          >
            {blacklistLoading ? (
              <>
                <span className='spinner-border spinner-border-sm me-2'></span>
                Blacklisting...
              </>
            ) : (
              'Blacklist User'
            )}
          </button>
          <button
            type='button'
            className='btn btn-sm btn-success'
            onClick={onUnblacklist}
            disabled={blacklistLoading || unblacklistLoading}
            data-kt-menu-dismiss='true'
          >
            {unblacklistLoading ? (
              <>
                <span className='spinner-border spinner-border-sm me-2'></span>
                Unblacklisting...
              </>
            ) : (
              'Unblacklist User'
            )}
          </button>
        </div>
      </div>
    </div>
  )
}
